"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringReplace = void 0;
var stringReplace = function (value) {
    return value
        .replace(/^[^a-zA-Z0-9]/, '')
        .replace(/[^a-zA-Z0-9]/g, '_')
        .toUpperCase();
};
exports.stringReplace = stringReplace;
// ([a-zA-Z0-9_]*)-?
